var beratungsbestaetigungen_selectFlaeche;

/**
 * beratungsbestaetigungenFlaechen_Index
 */
window.beratungsbestaetigungenFlaechen_Index = function() {
  beratungsbestaetigungen_selectFlaeche = $('.selectFlaeche');
  beratungsbestaetigungen_selectFlaeche.on('click', function() {
    // Select all Rows with Equal Genossenschaft Field
    if ($(this).prop('checked') === true) {
      var selectedGschaftid = $(this).data('gschaftid');
      var selectedGschaftMemberID = $(this).data('gschaftmemberid');
      beratungsbestaetigungen_selectFlaeche.each(function(k, v) {
        if ($(v).data('gschaftid') === selectedGschaftid && $(v).data('gschaftmemberid') === selectedGschaftMemberID) {
          $(v).prop('checked', true);
          var tr = $(v).parents()[1];
          $(tr).addClass('selected');
        }
      });
    } else {
      var tr = $(this).parents()[1];
      $(tr).removeClass('selected');
      $('#selectAll').prop('checked', false);
    }

    window.beratungsbestaetigungenFlaechen_checkSelectedFlaechen();
  });
};

/**
 * checkSelectedFlaechen
 */
window.beratungsbestaetigungenFlaechen_checkSelectedFlaechen = function() {
  var anyChecked = false;
  beratungsbestaetigungen_selectFlaeche.each(function(k, v) {
    var isChecked = $(v).prop('checked');
    if (isChecked) {
      anyChecked = true;
    }
  });
  if (anyChecked) {
    $('#create-beratungsbestaetigung').prop('disabled', false);
  } else {
    $('#create-beratungsbestaetigung').prop('disabled', true);
  }
};

/**
 * beratungsbestaetigungenFlaechen_submit
 * @param element
 */
window.beratungsbestaetigungenFlaechen_submit = function(element) {
  element.textContent = LANG_STRINGS.BITTE_WARTEN;
  element.disabled = true;
  element.closest('form').submit();
};

/**
 * beratungsbestaetigungen_Index
 * @param request_uri
 */
window.beratungsbestaetigungen_Index = function(request_uri) {
  $('.selectAusdruck').on('click', function() {
    var isOK = $(this).data('isok');

    if (isOK === 0) {
      ajaxDialog(BASE_PATH + 'ajax/dialog/beratungsbestaetigungWarnung', 742, {
        post_data: {
          request_uri: request_uri,
        },
      });
      $(this).prop('checked', false);
    }

    // Thru all checkboxes
    var anyChecked = false;
    $('.selectAusdruck').each(function(k, v) {
      var isChecked = $(v).prop('checked');
      if (isChecked) {
        anyChecked = true;
      }
    });
    // If any checkbox is checked, enabme upload button, else, disable it
    if (anyChecked) {
      $('#uploadBetriebsmappe-js').prop('disabled', false);
    } else {
      $('#uploadBetriebsmappe-js').prop('disabled', true);
    }
  });
};

/**
 * Upload Betriebsmappe
 * @param id
 * @param request_uri
 */
window.uploadBetriebsmappe = function(id, request_uri) {
  var bbIDs = [];
  $('.selectAusdruck').each(function(k, v) {
    if ($(v).prop('checked') === true) {
      bbIDs.push($(v).val());
    }
  });

  ajaxDialog(BASE_PATH + '/ajax/dialog/uploadBeratungsbestaetigungen?teilnehmerID=' + id, 742, {
    post_data: {
      request_uri: request_uri,
      data: bbIDs,
    },
  });
};
